import { getStateAtNamespaceKey } from 'redux/get-state-at-namespace-key';
import { SlotGridType } from 'api/definitions/slotdates/types';

export const getSelectedSlotGridType = (state: WtrState) =>
  getStateAtNamespaceKey(state, 'slotBooking').selectedSlotGridType || SlotGridType.DEFAULT_GRID;
